export enum DepartmentCode {
  Geodesy = 'GEO',
  EnvironmentalProtection = 'SRO',
  Construction = 'BUD',
  Planning = 'PLA'
}
